export default __webpack_public_path__ + "static/media/1557.1db04d3e.png";